<!-- Item wrapper -->
<div class="fuse-vertical-navigation-item-wrapper relative" [class.fuse-vertical-navigation-item-has-subtitle]="!!item.subtitle" [ngClass]="item.classes?.wrapper">
    <!-- Item with an internal link -->
    @if (item.link && !item.externalLink && !item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item group" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [routerLink]="[item.link]" [fragment]="item.fragment ?? null" [preserveFragment]="item.preserveFragment ?? false" [queryParams]="item.queryParams ?? null" [queryParamsHandling]="item.queryParamsHandling ?? null" [routerLinkActive]="'fuse-vertical-navigation-item-active'" [routerLinkActiveOptions]="isActiveMatchOptions" [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with an external link -->
    @if (item.link && item.externalLink && !item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item group" [href]="item.link" [target]="item.target || '_self'" [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with a function -->
    @if (!item.link && item.function && !item.disabled) {
    <div class="fuse-vertical-navigation-item group overflow-hidden text-ellipsis text-nowrap" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [matTooltip]="item.tooltip || ''" (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
    }

    <!-- Item with an internal link and function -->
    @if (item.link && !item.externalLink && item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item group" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [routerLink]="[item.link]" [fragment]="item.fragment ?? null" [preserveFragment]="item.preserveFragment ?? false" [queryParams]="item.queryParams ?? null" [queryParamsHandling]="item.queryParamsHandling ?? null" [routerLinkActive]="'fuse-vertical-navigation-item-active'" [routerLinkActiveOptions]="isActiveMatchOptions" [matTooltip]="item.tooltip || ''" (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with an external link and function -->
    @if (item.link && item.externalLink && item.function && !item.disabled) {
    <a class="fuse-vertical-navigation-item group" [href]="item.link" [target]="item.target || '_self'" [matTooltip]="item.tooltip || ''" (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
    }

    <!-- Item with a no link and no function -->
    @if (!item.link && !item.function && !item.disabled) {
    <div class="fuse-vertical-navigation-item group flex w-full overflow-hidden" [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active,
            }" [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
    }

    <!-- Item is disabled -->
    @if (item.disabled) {
    <div class="fuse-vertical-navigation-item fuse-vertical-navigation-item-disabled group" [matTooltip]="item.tooltip || ''">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
    }
</div>

<!-- Item template -->
<ng-template #itemTemplate>
    <!-- Icon -->
    @if (item.icon) {
    <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="item.classes?.icon" [svgIcon]="item.icon"></mat-icon>
    }

    <!-- Title & Subtitle -->
    <div class="fuse-vertical-navigation-item-title-wrapper flex w-full overflow-hidden">
        <div class="fuse-vertical-navigation-item-title flex w-full overflow-hidden">
            <span [id]="item.id + '-title'" [ngClass]="item.classes?.title" class="max-w-3/4" [contentEditable]="isEditingName" (keydown)="onKeyDown($event)" (focusout)="stopEditingName()" (click)="isEditingName ? $event.preventDefault() : null">
                {{ item.title }}
            </span>
        </div>
        @if (item.subtitle) {
        <div class="fuse-vertical-navigation-item-subtitle">
            <span [ngClass]="item.classes?.subtitle">
                {{ item.subtitle }}
            </span>
        </div>
        }
    </div>

    <!-- Badge -->
    @if (item.badge) {
    <div class="fuse-vertical-navigation-item-badge">
        <div class="fuse-vertical-navigation-item-badge-content" [ngClass]="item.badge.classes">
            {{ item.badge.title }}
        </div>
    </div>
    }

    <!-- If is Conversation -->
    @if (item.isConversation && !isEditingName) {
    <div class="absolute right-0 hidden h-full w-2/3 justify-end bg-gradient-to-l from-[#0F172A] group-hover:flex">
        <button mat-icon-button class="z-10" [matMenuTriggerFor]="itemMenu" (click)="$event.stopPropagation(); $event.preventDefault();">
            <mat-icon class="text-white" [svgIcon]="'heroicons_solid:ellipsis-vertical'"></mat-icon>
        </button>

        <!-- Mat menu -->
        <mat-menu #itemMenu="matMenu" class="rounded-xl p-2">
            <!-- Rinomina conversazione -->
            <button mat-menu-item class="flex w-full items-center justify-between p-2 px-4" (click)="$event.stopPropagation(); $event.preventDefault(); startEditingName()">
                <span>Rinomina</span>
                <mat-icon [svgIcon]="'heroicons_outline:pencil'" class="icon-size-4" [matTooltip]="'Rinomina Conversazione'"></mat-icon>
            </button>

            <!-- Elimina conversazione -->
            <button mat-menu-item class="flex w-full items-center justify-between p-2 px-4" (click)="$event.stopPropagation(); $event.preventDefault(); deleteConversation(item.id)">
                <span>Elimina</span>
                <mat-icon [svgIcon]="'heroicons_outline:trash'" class="icon-size-4" color="warn" [matTooltip]="'Elimina Conversazione'"></mat-icon>
            </button>
        </mat-menu>
    </div>
    }

    @if (isEditingName) {
    <div class="pointer-events-none absolute right-0 flex h-full w-2/3 justify-end">
        <button mat-icon-button class="pointer-events-auto z-10" (click)="stopEditingName()" (click)="$event.stopPropagation(); $event.preventDefault();">
            <mat-icon class="text-white icon-size-4" [svgIcon]="'heroicons_solid:arrow-uturn-up'"></mat-icon>
        </button>
    </div>
    }
</ng-template>